import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { LogoMark } from "../components/Logo";

const copy = {
  checking: ["Checking your order…", "Just a moment while we confirm your payment."],
  paid: ["Hooray, thank you!", "Your copy of The Party Pet Shop is on its way. Reuben is doing a happy dance."],
  pending: ["Still confirming…", "Your payment is taking a little longer. Please check your email shortly."],
  cancel: ["No worries!", "Your order was cancelled. The pet shop will still be here when you're ready."],
};

export default function PaymentResult({ cancelled = false }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancel" : "checking");

  useEffect(() => {
    if (cancelled || !sessionId) return undefined;
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/payments/status/${sessionId}`);
        if (data?.payment_status === "paid") { setState("paid"); return; }
      } catch { /* keep polling */ }
      if (tries >= 10) { setState("pending"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [cancelled, sessionId]);

  const [title, body] = copy[state];
  return (
    <main className="min-h-screen bg-ink text-cream grid place-items-center px-6 grain">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className="max-w-lg text-center" data-testid={`payment-${state}`}>
        <LogoMark className="w-16 h-16 mx-auto" />
        <h1 className="mt-8 font-display text-butter text-5xl sm:text-6xl">{title}</h1>
        <p className="mt-6 text-lg text-cream/85">{body}</p>
        <a href="/" data-testid="back-home-link" className="mt-10 inline-block rounded-full bg-butter text-ink font-bold px-8 py-4 hover:bg-coral hover:text-cream transition-colors">
          Back to Reuben's Reads
        </a>
      </motion.div>
    </main>
  );
}
